module.exports = __webpack_public_path__ + "img/3.d0426fc4.gif";